import React, { useState } from 'react';
import { downloadReport } from './service';

import { ArrowDownTrayIcon } from '@heroicons/react/20/solid';
import { LoadingSpinner } from 'components/shadcn/ui/loadingSpinner';
import Button from 'components/Button';
import { useToast } from 'components/shadcn/hooks/use-toast';
import { useJwtToken } from 'helper';

const ReportDownloadButton = ({ reportStatus, fileName }) => {
    const accessToken = useJwtToken();
    const { toast } = useToast();
    const [isDownloading, setIsDownloading] = useState(false);

    const handleDownloadReport = async () => {
        setIsDownloading(true);
        try {
            toast({
                title: 'Downloading Report',
                description:
                    'Report download initiated, please check your browser downloads list.',
            });
            const data = await downloadReport(fileName, accessToken);
            const fileUrl = atob(data.url);
            const reportName = data.reportName;
            const downloadLink = document.createElement('a');
            downloadLink.href = fileUrl;
            downloadLink.download = reportName;
            downloadLink.click();
        } catch (error) {
            console.error('Failed to download report', error.message);
            toast({
                title: 'Download Failed',
                description:
                    'Please try again later. Contact support if the issue persists.',
                variant: 'destructive',
            });
        } finally {
            setIsDownloading(false);
        }
    };
    return (
        <Button
            onClick={
                reportStatus === 'Finished' && !isDownloading
                    ? handleDownloadReport
                    : undefined
            }
            disabled={reportStatus !== 'Finished' || isDownloading}
            className={`${reportStatus !== 'Finished' || (isDownloading && 'cursor-not-allowed bg-slate-100')}`}
        >
            {isDownloading ? (
                <LoadingSpinner className="border-t-3 h-5 w-5 border-2" />
            ) : (
                <ArrowDownTrayIcon className="h-5 w-5" />
            )}
        </Button>
    );
};

export default ReportDownloadButton;
